module.exports = __webpack_public_path__ + "assets/img/img-map-kyushu-sp.8e9ff47f.svg";